import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqItems } from '@/mocks/tracking';

const PRINCIPLES = [
  { icon: 'ri-shield-check-line', title: '核实优先', desc: '先用可追溯来源，再用措辞定级' },
  { icon: 'ri-restart-line', title: '允许被打脸', desc: '状态变更会改写并标注，绝不硬撑' },
  { icon: 'ri-file-list-3-line', title: '搬运不站队', desc: '只搬运与标注，不替任何人下结论' },
  { icon: 'ri-archive-2-line', title: '长期可回溯', desc: '历史进度永久归档，方便对照反转' },
];

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  return (
    <section id="faq" className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">长期信任</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">频道怎么跑，先讲清楚</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                一个长期跟进在线黑料的频道，信任比热度更重要。下面是我们坚持的底线，也是判断任何一条跟踪报道该不该信的标准。
              </p>
              <ul className="mt-7 space-y-4">
                {PRINCIPLES.map((p) => (
                  <li key={p.title} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-200/70 text-foreground-700">
                      <i className={`${p.icon} text-base`} />
                    </span>
                    <div>
                      <p className="font-label text-sm font-semibold text-foreground-900">{p.title}</p>
                      <p className="mt-0.5 text-xs text-foreground-600">{p.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <div className="space-y-3 lg:col-span-7">
            {faqItems.map((item) => {
              const open = openId === item.id;
              return (
                <Reveal key={item.id}>
                  <div className={`rounded-lg border bg-background-50 transition-colors ${open ? 'border-accent-300' : 'border-background-200'}`}>
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? null : item.id)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-label text-sm font-semibold text-foreground-900">{item.q}</span>
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                          open ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-sm`} />
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}